import { fetch } from '../fetchWrapper/fetch';
import { IAddonsResponse } from './types';
import { MARKETPLACE_API_URL } from '../../constants';
import { IResMeta } from 'src/types';

export const getAddons = async (): Promise<IAddonsResponse[]> => {
  const res = await fetch(`${MARKETPLACE_API_URL}/addons`);
  if (res.status !== 200) {
    throw new Error('Could not fetch addons');
  }
  const json: IResMeta<IAddonsResponse[]> = await res.json();
  return json.data;
};
